import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import convert from 'convert-units';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchWeather, setWeatherTime,
  setLocalWeatherSite, setWeatherLocation, downloadWeather } from './actions';
import './weather.css';
import WeatherDislay from './components/weather_display';
import AirQualityDisplay from './components/airQuality_display';
import { VerticalSlider, HorizontalSlider, DatePicker, RadioButton } from './components/inputs';
import { StackedBarChartWithLine, LineChart } from './components/charts/misc_chart';
import DashboardCard from './components/dashboard_card';

const propTypes = {
  allLocations: PropTypes.array,
  displaying: PropTypes.array,
  view: PropTypes.object,
  weather: PropTypes.object,
  airQuality: PropTypes.object,
  downloadWeather: PropTypes.func,
  fetchWeather: PropTypes.func,
  setWeatherLocation: PropTypes.func,
  setLocalWeatherSite: PropTypes.func,
  setWeatherTime: PropTypes.func
};

class Weather extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barLineChart: null,
      lineChart: null
    };
    this._fetchWeather = this._fetchWeather.bind(this);
    this._downloadWeather = this._downloadWeather.bind(this);
    this.drawWeatherChart = this.drawWeatherChart.bind(this);
    this.drawAirQualityChart = this.drawAirQualityChart.bind(this);
  }
  componentDidMount() {
    this.props.fetchWeather(moment().format('YYYY-MM-DD'));
    document.title = 'Weather';
  }
  componentWillReceiveProps(newProps) {
    this.drawWeatherChart(newProps.view.dataset.weather);
    this.drawAirQualityChart(newProps.view.dataset.airQuality);
  }
  _fetchWeather(date) {
    if (date === '') return;
    return this.props.fetchWeather(moment(date).format('YYYY-MM-DD'));
  }
  _downloadWeather(date1, date2) {
    if (date1 === '' && date2 === '') return;
    return this.props.downloadWeather(moment(date1).format('YYYY-MM-DD'), moment(date2).format('YYYY-MM-DD'), this.props.user.email);
  }
  drawWeatherChart(props) {
    if (!props) return;
    if (this.state.barLineChart) this.state.barLineChart.destroy();

    var ctx = document.getElementById("weather-chart").getContext("2d");
    var labels = props.map((val) => {
      let time = val.observation_time.split(' ')[1];
      return moment(time, 'HH').format("h:mm:ss A");
    });
    var temp = props.map((val) => val.temp);
    var humidity = props.map((val) => val.humidity);
    let precipitation = props.map((val) => convert(val.precipitation).from('in').to('mm'));
    // Params: ctx, labels, data1, data2, data3, label1, label2, label3
    var barLineChart = StackedBarChartWithLine({
      ctx,
      labels,
      data1: precipitation,
      data2: humidity,
      data3: temp,
      label1: 'Precipitation (mm)',
      label2: 'Humidity %',
      label3: 'Temperature'
    });
    this.setState({barLineChart});
  }
  drawAirQualityChart(props) {
    if (!props) return;
    if (this.state.lineChart) this.state.lineChart.destroy();
    var ctx = document.getElementById("airQuality-chart").getContext("2d");
    var labels = props.map((val) => {
      let time = val.observation_time.split(' ')[1];
      return moment(time, 'HH').format("h:mm:ss A");
    });
    var aq = props.map((val) => val.epa_aqi);
    // Params: ctx, labels, data, label
    var lineChart = LineChart({
      ctx,
      labels,
      data: aq,
      label: 'EPA Air Quality Index'
    });
    this.setState({lineChart});
  }
  render() {
    return (
      <div>
        <div className="card z-depth-4">
          <div className="card-content">
            <div className="row">
              <div className="col s12 m12 l12 xl2">
                <span className="card-title">
                  Location: <b>{ this.props.view.location === 71 ? `Pahala` :
                    this.props.view.location === 72 ? `Kea'au` :
                    this.props.view.location === 75 ? `Na'alehu` : 'N/A' }</b> <br />
                  Site: <b>{ this.props.view.name }</b> <br />
                  Date: <b>{ this.props.view.date }</b> <br />
                  Time: <b>{ `${this.props.view.time}:00` }</b>
                </span>
                <p>Last Updated: {this.props.view.lastUpdated}</p>
                <div className="weather-home">
                  <RadioButton id={'weather-pahala'} name={'weather-loc'} label={`Pahala`} value={71} onClick={(e) => this.props.setWeatherLocation(e.target.value)} />
                  <RadioButton id={'weather-keaau'} name={'weather-loc'} label={`Kea'au`} value={72} onClick={(e) => this.props.setWeatherLocation(e.target.value)} />
                  <RadioButton id={'weather-naalehu'} name={'weather-loc'} label={`Na'alehu`} value={75} onClick={(e) => this.props.setWeatherLocation(e.target.value)} />
                </div><br />
                <div className="date-fetch">
                  <DatePicker id={'weather-fetch'} label={'Select a Date'} _class={'w-date'} />
                  <button className="btn waves-effect"
                    onClick={() => this._fetchWeather(document.getElementById('weather-fetch').value)}>
                    Fetch
                  </button>
                </div>
              </div>
              <div className="col s12 m12 l12 xl5 hide-on-small-only">
                <DashboardCard canvasId={'weather-chart'} label={'Weather'} />
              </div>
              <div className="col s12 m12 l12 xl5 hide-on-small-only">
                <DashboardCard canvasId={'airQuality-chart'} label={'Air Quality'} />
              </div>

            </div>
            <div className="row">
              <div className="col s12">
                <HorizontalSlider id={'weather-time'} _class={'sl'} label={'Time'} min={"1"} max={"19"}
                  defaultValue={"1"} onChange={(val) => this.props.setWeatherTime(val, this.props.allLocations, this.props.view.loc)} />
              </div>
            </div>
            <div className="row">
              <div className="col s1 m1 l1 xl1">
                <div>
                  <VerticalSlider id={'weather-location'} label={'Site'} _class={'sl slider'} min={Math.min(...this.props.displaying.map((d) => d.id))}
                    defaultValue={`${this.props.view.loc}`} max={Math.max(...this.props.displaying.map((d) => d.id))}
                    onChange={(val) => this.props.setLocalWeatherSite(val, this.props.allLocations, this.props.view.time)} />
                  </div>
              </div>
              <div className="col s11 m11 l11 xl11 ">
                <div className="row">
                  {/* Weather */}
                  <div className="col s12 m12 l6 xl6">
                    <WeatherDislay weather={this.props.weather} />
                  </div>
                  {/* Air Quality */}
                  <div className="col s12 m12 l6 xl6">
                    <AirQualityDisplay airQuality={this.props.airQuality} />
                  </div>
                </div>
                <div className="row">
                  <div className="col s6 m3 l3 xl3 b-l">
                    <strong>Location</strong>
                    <p>{ this.props.view.location === 71 ? `Pahala` :
                      this.props.view.location === 72 ? `Kea'au` :
                      this.props.view.location === 75 ? `Na'alehu` : 'N/A' }</p>
                  </div>
                  <div className="col s6 m3 l3 xl3 b-l">
                    <strong>Site</strong>
                    <p>{ this.props.view.name }</p>
                  </div>
                  <div className="col s6 m3 l3 xl3 b-l">
                    <strong>Date</strong>
                    <p>{ this.props.view.date }</p>
                  </div>
                  <div className="col s6 m3 l3 xl3 b-l">
                    <strong>Time</strong>
                    <p>{ `${this.props.view.time}:00` }</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-action">
            <div className="row">
              <div className="col s12 m12 l12 xl12">
                <label><u>Email Weather & Air Quality Data</u></label>
                <div className="date-row">
                  <span className="pr-5"><DatePicker id={'weather-date1'} label={'From'} _class={'w-date'} /></span>
                  <span className="pr-5"><DatePicker id={'weather-date2'} label={'To'} _class={'w-date'} /></span>
                  <span className="center-btn"><button className="btn waves-effect"
                    onClick={() => this._downloadWeather(document.getElementById('weather-date1').value, document.getElementById('weather-date2').value)}>
                    Email
                  </button></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    allLocations: state.weather.locations.all,
    displaying: state.weather.locations.displaying,
    view: state.weather.view,
    weather: state.weather.view.datapoint.weather,
    airQuality: state.weather.view.datapoint.airQuality
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    downloadWeather,
    fetchWeather,
    setWeatherLocation,
    setLocalWeatherSite,
    setWeatherTime
  }, dispatch);
}
Weather.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(Weather);



// WEBPACK FOOTER //
// ./src/weather/weather.js